import { Component, OnInit } from '@angular/core';
import { AppService } from '../../shared/services/app.service';
import { DialogConfig } from '../dialog/dialog-config';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss'],
  standalone: false
})
export class TncComponent implements OnInit {
  eula: boolean = true;
  privacy: boolean = false;
  eulaList: any = false;
  public _currentData: any = {};
  constructor(
    private appService: AppService,
    private dialogConfig: DialogConfig,
    // private router: Router
    private Aroute: ActivatedRoute
  ) { }

  ngOnInit() {
    var eulaList: any = null;
    if (this.Aroute.snapshot.params['id'] && this.appService.getAppHeader() && this.appService.getAppHeader().eula_document_links) {
      eulaList = this.appService.getAppHeader().eula_document_links;
      let selectedDOC = eulaList? eulaList.filter(eula => eula.eula_title.toLowerCase() == this.Aroute.snapshot.params['id'].replace("_", ' ').toLowerCase()): [];
      if (selectedDOC.length > 0) {
        this._currentData = selectedDOC[0];
      }
    } else {
      eulaList = this.appService.getEula();
      if (eulaList) {
        for (let eula of eulaList) {
          eula.url = eula.documentUri;
        }
        this.eulaList = eulaList;
        this._currentData = this.eulaList? this.eulaList[0] : {};
        if (this.dialogConfig && this.dialogConfig['label'] == 'User Manual') {
          for (let eula of this.eulaList) {
            if (eula['eula_title'] == 'User Manual') {
              this._currentData = eula
            }
          }
        }
      }
    }

  }

  selectDoc(eula) {
    this._currentData = eula;
  }

}
